/** True when the file should be sent as a listing photo (handles empty MIME on Windows). */
export function isListingImageFile(file: File): boolean {
  if (file.type.startsWith('image/')) return true;
  if (file.type && file.type !== 'application/octet-stream') return false;
  return /\.(jpe?g|png|gif|webp|bmp|heic|heif|avif)$/i.test(file.name);
}
